module.exports = __webpack_public_path__ + "img/img_2.cc2bfe55.jpeg";